import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}


if (window.trustedTypes) {
  window.trustedTypes.createPolicy('angular', {
    createHTML: (input) => input,
    createScript: (input) => input,
    createScriptURL: (input) => input,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));


const metaTag = document.createElement('meta');
metaTag.setAttribute('http-equiv', 'Content-Security-Policy');
metaTag.setAttribute(
  'content',
  `
    default-src 'self';
    script-src 'self' ${location.origin};
    media-src 'self' *;
    frame-src 'self' *;
    base-uri 'self';
    style-src 'self' 'unsafe-inline' ${location.origin} https://fonts.googleapis.com;
    connect-src 'self' ${location.origin} https://sentry.onix.team https://ipapi.co/json;
    img-src data: *;
    font-src 'self' data: fonts.gstatic.com
  `
);
document.head.appendChild(metaTag);
